import stringify from 'fast-json-stable-stringify'
import { FacetFilter } from '../backend/typesense/FacetFilter'

export function serializeFilter(filter: FacetFilter) {
	const defaultFilter = FacetFilter.parse({})
	const minified = FacetFilter.parse(JSON.parse(stringify(filter)))

	Object.entries(defaultFilter).forEach(([key, value]) => {
		const a = value
		const b = minified[key]
		if (stringify(a) === stringify(b)) {
			delete minified[key]
		}
	})

	const serialized = stringify(minified)
	if (serialized === '{}') {
		return null
	}
	return serialized
}
